import {RouterModule} from '@angular/router';
import { TokenModalComponent } from './modals/token-modal.component';
import { TokensComponent } from './tokens.component';

const modalRoute = [
    {
        path: 'create', component: TokenModalComponent,
        data: {
            type: 'read'
        }
    }
];

export const TokenRoutesModule = RouterModule.forChild([
    {
        path: '', component: TokensComponent,
    },
    {
        path: 'tokens', component: TokensComponent,
        data: {
            alias: 'tokens.index',
            reload: false,
        },
        children: modalRoute
    },
]);
